import { CdkVirtualScrollViewport, ExtendedScrollToOptions, VirtualScrollStrategy } from '@angular/cdk/scrolling';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { GridVirtualizationConfig } from '../grid-ins.component';

@Injectable({ providedIn: 'root' })
export class TableVirtualScrollStrategy implements VirtualScrollStrategy {
    private config!: GridVirtualizationConfig;

    private readonly indexChange = new Subject<number>();

    private viewport!: CdkVirtualScrollViewport;

    public scrolledIndexChange!: Observable<number>;

    private verticalScrollPosition!: number;

    public constructor() {
        this.scrolledIndexChange = this.indexChange.asObservable().pipe(distinctUntilChanged());
    }

    public attach(viewport: CdkVirtualScrollViewport): void {
        this.viewport = viewport;
        this.onDataLengthChanged();
        this.updateContent();
    }

    public onContentScrolled(): void {
        const newTopPosition = this.viewport.elementRef.nativeElement.scrollTop;
        if (newTopPosition !== this.verticalScrollPosition) this.updateContent();

        this.verticalScrollPosition = newTopPosition;
    }

    public onDataLengthChanged(): void {
        const rowHeight = this.config?.rowHeight ?? 0;
        const dataLength = this.viewport?.getDataLength() ?? 0;
        const totalContentSize = dataLength * rowHeight;
        this.viewport?.setTotalContentSize(totalContentSize);
    }

    public setViewportConfig(config: GridVirtualizationConfig): void {
        this.config = config;
        this.updateContent();
    }

    public get inverseOfTranslation(): number {
        if (!this.viewport || !this.viewport['_renderedContentOffset']) {
            return 0;
        }
        const offset = this.viewport['_renderedContentOffset'];

        return offset;
    }

    public updateContent(): void {
        if (!this.viewport || !this.config) return;
        const scrollOffset = this.viewport.measureScrollOffset();
        const rowHeight = this.config.rowHeight ?? 60;
        const headerHeight = this.config.headerHeight ?? 60;
        const bufferSize = this.config.bufferSize ?? 10;

        const newIndex = Math.round((scrollOffset - headerHeight) / rowHeight);
        const newRange = Math.max(0, newIndex - bufferSize);

        this.viewport.setRenderedContentOffset(rowHeight * newRange);
        this.indexChange.next(newIndex);
    }

    public scroll(options: ExtendedScrollToOptions): void {
        this.viewport?.scrollTo(options);
    }

    public onContentRendered(): void { } // no-op

    public onRenderedOffsetChanged(): void { } // no-op

    public scrollToIndex(index: number, behavior: ScrollBehavior): void { } // no-op

    public detach(): void { } // no-op
}
